(() => {
  'use strict';
  function storeUrl(current, base) {
    const source = new URL(current);
    const target = new URL(base);
    const baseParams = new URLSearchParams(target.search);
    const path = source.pathname.replace(/^\/(?:[a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/i, '') || '/';
    target.pathname = target.pathname.replace(/\/$/, '') + path;
    target.search = source.search;
    target.searchParams.delete('siteRegion');
    target.searchParams.delete('country');
    target.searchParams.delete('discount');
    for (const [key, value] of baseParams) target.searchParams.set(key, value);
    target.hash = source.hash;
    return target.href;
  }
  function authenticatedStoreUrl(current, base, auth) {
    const target = new URL(storeUrl(current, base));
    const trustedHosts = ['strutt.us', 'strutt.inc', 'uk.strutt.inc', 'eu.strutt.inc',
      'gfhpc0-p9.myshopify.com', 'sy10cy-bd.myshopify.com', '321eeeus.myshopify.com'];
    if (target.origin === new URL(current).origin || target.protocol !== 'https:' ||
        target.port || !trustedHosts.includes(target.hostname)) return target.href;
    const at = auth?.getAccessToken?.();
    const rt = auth?.getRefreshToken?.();
    const valid = value => typeof value === 'string' && /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(value);
    if (!valid(at) || !valid(rt)) return target.href;
    const fragment = new URLSearchParams({ _points_auth: '1', at, rt, anchor: target.hash.slice(1) });
    target.hash = fragment.toString();
    return target.href;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { storeUrl, authenticatedStoreUrl };
  if (typeof document === 'undefined') return;
  function initialize() {
    const url = new URL(location.href);
    if (url.searchParams.has('siteRegion')) {
      url.searchParams.delete('siteRegion');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
    const contextNode = document.querySelector('[data-points-context]');
    if (!contextNode || typeof window.PointsAPI !== 'function') return;
    const context = JSON.parse(contextNode.textContent);
    const fallback = window.PointsAPI.selectedRegion(context.region);
    const selectors = [...document.querySelectorAll('[data-points-store-selector]')].filter(selector => !selector.dataset.initialized);
    if (!selectors.length) return;
    // Handle rejection immediately, even if a selector contains older markup.
    const marketsRequest = new window.PointsAPI(fallback).getMarkets().catch(() => null);
    selectors.forEach(selector => {
      if (selector.dataset.initialized) return;
      selector.dataset.initialized = 'true';
      selector.setAttribute('aria-busy', 'true');
      const region = selector.dataset.currentStore || fallback;
      const currentMarket = region;
      selector.querySelectorAll('[data-store-region]').forEach(option => {
        option.href = storeUrl(url.href, option.dataset.storeBaseUrl);
        const prepareNavigation = () => {
          // Read cookies at navigation time so refreshed or cleared tokens are respected.
          option.href = authenticatedStoreUrl(location.href, option.dataset.storeBaseUrl, window.authAPI);
          if (option.dataset.storeRegion !== currentMarket) {
            try { sessionStorage.removeItem('points-selected-discount'); } catch (_) { /* Storage may be disabled. */ }
          }
        };
        option.addEventListener('click', prepareNavigation);
        option.addEventListener('auxclick', prepareNavigation);
        if (option.dataset.storeRegion === currentMarket) {
          option.setAttribute('aria-current', 'true');
          const label = selector.querySelector('[data-store-label]');
          const name = option.querySelector('[data-store-name]');
          if (label && !selector.dataset.currentStore) label.textContent = (name || option).textContent;
        }
      });
      selector.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          selector.open = false;
          selector.querySelector('summary').focus();
        }
      });
      document.addEventListener('click', event => { if (!selector.contains(event.target)) selector.open = false; });
      marketsRequest.then(markets => {
        if (!selector.isConnected) return;
        if (!markets) {
          selector.hidden = true;
          selector.open = false;
          return;
        }
        let count = 0;
        selector.querySelectorAll('[data-store-region]').forEach(option => {
          const market = markets.find(item => item.siteRegion === option.dataset.storeRegion);
          option.hidden = !market;
          if (market) {
            count++;
            const points = option.querySelector('[data-store-points]');
            if (points) {
              points.hidden = false;
              points.textContent = market.available.toLocaleString(document.documentElement.lang || 'en');
            }
          }
        });
        selector.hidden = count === 0 || (count === 1 && markets.some(market => market.siteRegion === currentMarket));
      }).catch(() => {
        selector.hidden = true;
        selector.open = false;
        // No hardcoded fallback markets: a failed request must not imply balances.
      }).finally(() => selector.setAttribute('aria-busy', 'false'));
    });
  }
  // Deferred section scripts may load this file before points-api.js.
  // Retry after all deferred dependencies have run; initialized selectors are skipped.
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  if (document.readyState !== 'loading') initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
